<template>

  <div class="swiper-box">
    <swiper :options="swiperOption1" ref="mySwiper">
      <swiper-slide v-for="item in newsSwiperRes" :key="item.newsId">
        <div class="news-item " @click="toDetails(item.newsId)">
          <img :src="item.newsImage" class="news-img hand" />
          <div class="title">{{ item.newsTitle }}</div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination1" slot="pagination"></div>
    <div class="swiper-button-prev1 items-center justify-center hand" v-if="isPc == 1">
      <svg-icon icon-class="arrow"></svg-icon>
    </div>
    <div class="swiper-button-next1 items-center justify-center hand" v-if="isPc == 1">
      <svg-icon icon-class="arrow"></svg-icon>
    </div>
  </div>

</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,

  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      typeId: "",
      newsSwiperRes: [],
      swiperOption1: {
        slidesPerView: 1, //一页显示几个
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        speed: 1500,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
        },
        autoplay: {
          delay: 6000, //自动切换的时间间隔
          disableOnInteraction: false,
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next1", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev1", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled1", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden", //按钮隐藏时的Class
        },
      },
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  watch: {
    list: {
      handler: function () {
        this.newsSwiperRes = this.list.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          return item;
        });
      },
      immediate: true,
    },
  },
  methods: {
    toDetails(newsId, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/expert-details/${newsId}`,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.swiper-box {
  width: 100%;
  position: relative;

  .news-item {
    position: relative;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 600px;
      object-fit: cover;
      display: block;
    }

    .title {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .3);
      padding: 40px 24px 58px;
      color: #fff;
      font-size: 40px;
    }
  }
}

.swiper-button-prev1 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);
  transform: translateY(-50%) rotate(180deg);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.swiper-button-next1 {
  right: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  width: 35px;
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  background: rgba(0, 0, 0, .08);

  .svg-icon {
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}

.my-button-disabled1 {
  background: rgba(0, 0, 0, .01);

  .svg-icon {
    color: rgba(255, 255, 255, .4);
  }
}

@media screen and (max-width: 768px) {
  .main {
    background: #edeff1;
  }

  .swiper-box {
    width: 100%;
    position: relative;
    padding: 10px;

    .news-item {
      position: relative;
      width: 100%;
      flex-direction: column;

      img {
        width: 100%;
        min-width: 100%;
        height: 206px;
        object-fit: cover;
      }

    }
  }

}
</style>
<style>
.swiper-box .swiper-pagination1 {
  position: absolute;
  bottom: 27px;
  z-index: 9;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.swiper-box .swiper-pagination-bullet {
  width: 73px;
  height: 4px;
  margin: 0.1px 7px 0;
  opacity: 0.5;
  background-color: #fff;
  border-radius: 0;
}

.swiper-box .swiper-pagination-bullet-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/expert/banner.vue